import React, {useState, useEffect} from "react";
import {CircularProgressCustom} from "../common-components/CircularProgressCustom";

import {apiUrl} from "../../../services/constants";

import {Container, Row, Col} from "react-bootstrap";
import Slider from "../Slide/Slide";
import "./home.css";
import cbs from "../../assets/images/marks/cbs.svg";
import chevrolet from "../../assets/images/marks/chevrolet.svg";
import maccarran from "../../assets/images/marks/mccarran.svg";
import staples from "../../assets/images/marks/staples.svg";
import disney from "../../assets/images/marks/disney.svg";
import Leader from "../../assets/images/Leader.png";
import certificate1 from "../../assets/images/certificate1.png";
import certificate2 from "../../assets/images/certificate2.png";
import certificate3 from "../../assets/images/certificate3.png";
import {BsArrowRight} from "react-icons/bs";
import {FcCheckmark} from "react-icons/fc";
import {useNavigate} from "react-router-dom";
import {FcApproval} from "react-icons/fc";

import NewProducts from "./NewProduct";
import NewCaseStudies from "./new_case_studies";


const Home = () => {
    const navigate = useNavigate();

    // const [total, setTotal] = useState(20);
    const [data, setData] = useState(null);
    const [error, setError] = useState(false);


    //const total_products = useQuery(GET_TOTAL_PRODUCTS);


    // useEffect(() => {
    //     if (total_products.data) {
    //         setTotal(total_products.data.products.meta.pagination.total);
    //     }
    // }, [total_products]);


    const fetchGraphQL = async (endpoint) => {
        const response = await fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
        });
        if (!response.ok) throw new Error(`Error: ${response.status}`);
        return response.json();
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [banner, categories] = await Promise.all([
                    fetchGraphQL('/api/graphql/get-banner'),
                    fetchGraphQL('/api/graphql/get-categories'),
                ]);
                setData({banner, categories});
            } catch (error) {
                setError(true);
            }
        };

       void fetchData();
    }, []);


    const renderProducts = () => {
        if (data.categories.data.categories.length === 0) {
            return (<h1>There are no products in stock</h1>);
        } else {
            if (data.categories.data.length === 0) {
                return (<h1>There is no such category</h1>);
            } else {
                return data.categories.data.categories &&
                    data.categories.data.categories.data.map((category, key) => {
                        return (
                            <Col md={3} className="mt-4" key={key}>
                                {/* <div style={{ height: "260px", backgroundColor: "#F5F5F5F5" }}></div> */}
                                <img
                                    src={
                                        apiUrl +
                                        category.attributes.collections
                                            .data[0].attributes.image
                                            .data?.attributes.url
                                    }
                                    alt={category.attributes.name}
                                    style={{
                                        height: "260px",
                                        width: "100%",
                                        backgroundColor: "#F5F5F5F5"
                                    }}
                                />
                                <h4 className="mt-3">
                                    {category.attributes.name}
                                </h4>
                                <span
                                    className="view-all-link"
                                    onClick={() =>
                                        navigate("/products")
                                    }
                                >
                                            VIEW ALL <BsArrowRight/>
                                        </span>
                            </Col>
                        );
                    });
            }
        }
    }


    const renderBanner = () => {
        if(!data) {
            return null;
        }

        const bannerdData = data.banner.data;
        if (bannerdData) {

            if (bannerdData.banners.data.length) {

                const bannerParams = bannerdData.banners.data[0];
                if (bannerParams.attributes.BannerText.length) {
                    return (
                        <div className="banner-container">
                            <Container>
                                <Row className="justify-content-md-center align-items-center">
                                    <Col md={6}>
                                        <h4 className="fw-light text-white">{bannerParams.attributes.BannerText}</h4>
                                    </Col>
                                    <Col md={2}>
                                        <img src={apiUrl + bannerParams.attributes.BannerImage.data.attributes.url}
                                             className="banner-image"
                                             alt={""}/>
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                    );
                }
            }
        }

    }

    return (
        <React.Fragment>
            {renderBanner()}

            <div className="slide-container">
                <Slider/>
            </div>

            <div className="all-products">
                <Container className="products">
                    <Row className="products-descritions">
                        <Col md={6}>
                            <h2>
                                An extensive product portfolio backed by a 100%
                                satisfaction guarantee
                            </h2>
                        </Col>
                        <Col md={6}>
                            <p>
                                At DSSL, we stand by our products and we back
                                them with sound customer support and some of the
                                best warranties in the business. Our robust line
                                of LED products made or assembled in America
                                complies with Buy American Act and American
                                Reinvestment & Recovery Act requirements.
                            </p>
                        </Col>
                    </Row>
                    <Row className="products-items mt-5">
                        {
                            !data ? <CircularProgressCustom/> : renderProducts()
                        }
                        {
                            error &&
                            <h1>Sorry... We have some error</h1>
                        }
                    </Row>
                    <Row
                        style={{
                            alignItems: "center",
                            justifyContent: "center",
                            marginBottom: "80px"
                        }}
                    >
                        <a
                            className="view-all-products-btn"
                            onClick={() => navigate("/products")}
                        >
                            <div>
                                VIEW ALL PRODUCTS{" "}
                                <BsArrowRight style={{marginLeft: "20px"}}/>
                            </div>
                        </a>
                    </Row>
                </Container>
            </div>

            <div className="markers mt-5">
                <Container>
                    <Row className="market-title">
                        <p>WHO WE'VE WORKED WITH</p>
                    </Row>
                    <Row className="marker-items mt-3">
                        <div>
                            <img src={cbs} alt="cbs"/>
                        </div>
                        <div>
                            <img src={chevrolet} alt="chevrolet"/>
                        </div>
                        <div>
                            <img src={maccarran} alt="maccarran"/>
                        </div>
                        <div>
                            <img src={staples} alt="staples"/>
                        </div>
                        <div>
                            <img src={disney} alt="disney"/>
                        </div>
                    </Row>
                </Container>
            </div>
            <div className="home-certificate mt-5">
                <Container>
                    <Row>
                        {/*<Col md={8} className="d-flex flex-row mt-5">*/}
                        <Col md={4} sm={12} xs={12} style={{textAlign: 'center'}}>
                            <img
                                src={certificate1}
                                alt="certificate1"
                                style={{margin: "20px"}}
                            />
                        </Col>
                        <Col md={4} sm={12} xs={12} style={{textAlign: 'center'}}>
                            <img
                                src={certificate2}
                                alt="certificate2"
                                style={{margin: "20px"}}
                            />
                        </Col>
                        <Col md={4} sm={12} xs={12} style={{textAlign: 'center'}}>
                            <img src={certificate3} alt="certificate3" style={{margin: "20px"}}/>
                        </Col>
                        {/*</Col>*/}
                    </Row>
                    <Row>
                        <Col md={12} className="mt-5">
                            <h2 className="cert-reg">REGISTRATIONS & CERTIFICATIONS</h2>
                            <div className="cert-label">
                                <div><FcApproval className='cert-icon' size={40}/></div>
                                <h2>SBA 8(a) CERTIFIED</h2>
                            </div>
                            <div className="cert-label">
                                <div><FcApproval className='cert-icon' size={40}/></div>
                                <h2>NDOT DISADVANTAGED & SMALL BUSINESS ENTERPRISE</h2>
                            </div>
                            <div className="cert-label">
                                <div><FcApproval className='cert-icon' size={40}/></div>
                                <h2>NMSDC MINORITY BUSINESS ENTERPRISE</h2></div>
                            <div className="cert-label">
                                <div><FcApproval className='cert-icon' size={40}/></div>
                                <h2>SAM.GOV REGISTERED SUPPLIER</h2>
                            </div>
                            <div className="cert-label">
                                <div><FcApproval className='cert-icon' size={40}/></div>
                                <h2>SBA DYNAMIC SMALL BUSINESS</h2>
                            </div>
                        </Col>
                    </Row>

                </Container>
            </div>

            <NewProducts/>
            <div className="about-us">
                <Container>
                    <Row>
                        <Col md={6}>
                            <Row>
                                <h2>
                                    An emerging leader in the lighting industry
                                    with representatives nationwide
                                </h2>
                                <div className="mt-4 about-us-list">
                                    <p>
                                        <FcCheckmark className="check-mark"/>
                                        Reliable, American-made products
                                    </p>
                                    <p>
                                        <FcCheckmark className="check-mark"/>
                                        Custom manufacturing & design
                                    </p>
                                    <p>
                                        <FcCheckmark className="check-mark"/>
                                        Specification-grade fixtures
                                    </p>
                                    <p>
                                        <FcCheckmark className="check-mark"/>
                                        Exceptional service & technical info
                                    </p>
                                    <p>
                                        <FcCheckmark className="check-mark"/>
                                        Solid warranties & after-sales support
                                    </p>
                                </div>
                                <button
                                    className="mt-4 learn-about-us-btn"
                                    onClick={() => navigate("/learn")}
                                >
                                    LEARN MORE ABOUT US{" "}
                                    <BsArrowRight
                                        style={{marginLeft: "20px"}}
                                    />
                                </button>
                            </Row>
                        </Col>
                        <Col md={6}>
                            <img src={Leader} alt="leader"/>
                        </Col>
                    </Row>
                </Container>
            </div>
            <NewCaseStudies/>
        </React.Fragment>
    );
};

export default Home;
